import { postsByCategory } from '../api'
import pagination from '../pagination'
import select from '../select'
import morePost from '../more-post'

const blog = {
  elements: {
    button: document.querySelector('.CardPostWrapper-btn'),
    container: document.querySelector('.CardPostSection-list'),
    loaderContainer: document.querySelector('.CardPostSection')
  },

  markup: ({ data }) => {
      const buttonText = blog.elements.container && blog.elements.container.getAttribute('buttonText')
      return data
      .map(
        ({ title, excerpt_post, link, featured_media_post, id }) => (
          `
            <a href='${link}' id='post-${id}' title='${title.rendered}' class='CardPost'>
              ${
                !!featured_media_post
                  ? `
                    ${featured_media_post}
                    `
                  : ''
              }
              <div class='CardPost-content'>
                <h3 class='CardPost-title'>${title.rendered}</h3>
                <p class='CardPost-excerpt'>
                  ${excerpt_post}
                </p>
              </div>
              <div class='CardPost-footer'>
                <div class='CardPost-btn Btn Btn-christi'>${buttonText}</div>
              </div>
            </a>
          `
        )
      )
      .join('')
  },

  loading: () => `<div class="List-loading"><span></span><span></span><span></span></div>`,

  init: async ({ ...props }) => {
    const url = new URL(window.location)
    const container = blog.elements.container

    if( ! document.querySelector('.CardPostSection-title') ) {
      return;
    }

    if (props.forceLoad) {
      if (container) {
        container.classList.add('loading')
        blog.elements.loaderContainer.classList.add('loading')

        if(!blog.elements.loaderContainer.querySelector('.List-loading')) {
          blog.elements.loaderContainer.prepend(
            document.createRange().createContextualFragment(blog.loading())
          );
        }
      }
    }

    const { data, totalPages, pageCurrent, categoryId } = await postsByCategory(
      { ...props, postType: postType }
    )

    if (props.forceLoad) {
      const list = await data

      if (!list.length) {
        if (container) {
          container.innerHTML = '<h2>' + clubei18n.nenhumresultado + '</h2>'
          container.classList.remove('loading')
          blog.elements.loaderContainer.classList.remove('loading')
        }
      } else {
        if (container) {
          container.innerHTML = await blog.markup({ data: list })
          container.classList.remove('loading')
          blog.elements.loaderContainer.classList.remove('loading')
        }
      }
    }

    // set category
    if ( ! document.querySelector('#categoryShowPostBlock')) {
      const newInput = document.createElement('input')
      newInput.setAttribute('id', 'categoryShowPostBlock')
      newInput.setAttribute('type', 'hidden')
      newInput.setAttribute('value', categoryId)
      document.querySelector('.CardPostWrapper').prepend(newInput)
    } else {
      document.querySelector('#categoryShowPostBlock').setAttribute('value', categoryId)
    }

    url.searchParams.set('pagina', pageCurrent)
    window.history.pushState({}, '', url)

    if (props.forceLoad) {
      if (blog.elements.button) {
        blog.elements.button.classList.remove('loading')
      }
    }

    if (totalPages === pageCurrent && blog.elements.button) {
      blog.elements.button.style.display = 'none'
    }

    pagination.init({
      totalPages,
      pageCurrent,
      categoryId,
      author,
      postType: layout,
      wrapper: '.CardPostSection',
      forceLoad: props.forceLoad
    })
  }
}

const isMobile = window.innerWidth < 576
const url = new URL(window.location)
const author = (document.querySelector('#listAuthorID')) ? document.querySelector('#listAuthorID').value : null
const category = document.querySelector('#categoryShow')
  ? document.querySelector('#categoryShow').value
  : ( document.querySelector('#listSelectionPostBlock') ) ? document.querySelector('#listSelectionPostBlock').value : null
const pageCurrent = url.searchParams.get('pagina')
// const firstPage = Number(pageCurrent) === 1 ? 0 : Number(pageCurrent)
const postType = document.querySelector('#postTypePostBlock')
  ? document.querySelector('#postTypePostBlock').value
  : 'posts';
const layout = 'blog';

const initialState = {
  id: Number(category) || 0,
  pageCurrent: Number(pageCurrent) || 1,
  perPage: 12,
  // offset: isMobile ? firstPage * 3 - 3 : '',
  author: author,
  typePost: postType,
  layout: layout,
  forceLoad: false,
}

blog.init({ ...initialState })
if (select && document.querySelector('.CardPostSection-title')) {
  select.init({ ...initialState, wrapper: '.CardPostSection-title' })
  morePost.init({ ...initialState })
}

export default blog
